// src/components/calendar/TrainingCalendar.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, Typography } from '@mui/material';
import AddEventModal from './AddEventModal';
import CalendarHeader from './CalendarHeader';
import MonthView from './MonthView';
import WeekView from './WeekView';

const TrainingCalendar = ({
    events,
    onEventDrop,
    onAddTraining,
    onEditTraining,
    onEventClick,
    onAddClick,
    trainingToEdit,
    setTrainingToEdit
}) => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [view, setView] = useState('month');
    const [showDialog, setShowDialog] = useState(false);

    // useEffect para abrir el modal cuando trainingToEdit cambia
    useEffect(() => {
        if (trainingToEdit) {
            setShowDialog(true);
        }
    }, [trainingToEdit]);

    // Función para manejar el cierre del modal
    const handleCancelEdit = useCallback(() => {
        setTrainingToEdit(null); // Limpia el entrenamiento a editar
        setShowDialog(false); // Cierra el modal
    }, [setTrainingToEdit]);

    // Función para manejar el clic en "Agregar" dentro del calendario
    const handleAddClickWrapper = useCallback((date) => {
        setTrainingToEdit(null); // Reinicia el entrenamiento a editar
        onAddClick(date); // Utiliza la función pasada por props
    }, [onAddClick, setTrainingToEdit]);

    return (
        <Card sx={{ width: '100%', maxWidth: '1200px', mx: 'auto' }}>
            <CardHeader
                title={
                    <Typography variant="h6">
                        {view === 'month'
                            ? currentDate.toLocaleString('default', { month: 'long', year: 'numeric' })
                            : `Week of ${currentDate.toLocaleDateString()}`
                        }
                    </Typography>
                }
                action={
                    <CalendarHeader
                        view={view}
                        setView={setView}
                        currentDate={currentDate}
                        setCurrentDate={setCurrentDate}
                    />
                }
            />
            <CardContent>
                {view === 'month' ? (
                    <MonthView
                        currentDate={currentDate}
                        events={events}
                        onEventDrop={onEventDrop}
                        onAddClick={handleAddClickWrapper}
                        onEventClick={onEventClick}
                    />
                ) : (
                    <WeekView
                        currentDate={currentDate}
                        events={events}
                        onEventDrop={onEventDrop}
                        onAddClick={handleAddClickWrapper}
                        onEventClick={onEventClick}
                    />
                )}
            </CardContent>

            <AddEventModal
                open={showDialog}
                onClose={handleCancelEdit}
                onAddTraining={onAddTraining}
                onEditTraining={onEditTraining}
                trainingToEdit={trainingToEdit}
                setTrainingToEdit={setTrainingToEdit}
                handleCancelEdit={handleCancelEdit}
            />
        </Card>
    );
};

export default TrainingCalendar;
